module.exports = __webpack_public_path__ + "static/img/APG.63659501.png";